var map = {
	"./app_strings.json": 50497,
	"./client/account_client.json": 8274,
	"./client/common_client.json": 2598,
	"./client/console.json": 65281,
	"./client/consultation_client.json": 38114,
	"./client/eyes.json": 39157,
	"./client/nav_client.json": 15759,
	"./client/patient_client.json": 80330,
	"./client/pdf.json": 3186,
	"./client/stats_client.json": 32021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87542;